// frontend/src/components/layout/Footer.jsx
import { Link } from "react-router-dom";
import { LEGAL_LINKS, ROUTES, SITE } from "../../config";
import { useBackendStatus } from "../common/BackendStatus";
import "./Footer.css";

const STATUS_COPY = {
  checking: "Checking service status…",
  ok: "All systems normal",
  degraded: "Running with reduced capacity",
  waking: "Server is waking up",
  down: "Server unreachable",
};

function StatusLine() {
  const { status, version } = useBackendStatus();
  return (
    <p className={`footer-status footer-status--${status}`}>
      <span className="footer-status__dot" aria-hidden="true" />
      <span>{STATUS_COPY[status] || STATUS_COPY.checking}</span>
      {version && status !== "down" && <span className="footer-status__ver">v{version}</span>}
    </p>
  );
}

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__top">
          <div className="site-footer__intro">
            <Link to={ROUTES.home} className="site-footer__brand" aria-label="PAWNI home">
              PAWNI
            </Link>
            <p className="site-footer__tag">
              A research project on asking better questions, so your models give better answers.
            </p>
            <StatusLine />
          </div>

          <nav className="site-footer__cols" aria-label="Footer">
            <div className="site-footer__col">
              <h2 className="site-footer__heading">Product</h2>
              <ul role="list">
                <li><Link to={ROUTES.app}>Open app</Link></li>
                <li><Link to="/#how-it-works">How it works</Link></li>
                <li>
                  <a href={SITE.paper.url} target="_blank" rel="noopener noreferrer">
                    Research paper
                  </a>
                </li>
              </ul>
            </div>

            <div className="site-footer__col">
              <h2 className="site-footer__heading">Legal</h2>
              <ul role="list">
                {LEGAL_LINKS.map((l) => (
                  <li key={l.to}><Link to={l.to}>{l.label}</Link></li>
                ))}
                <li><Link to={ROUTES.admin} className="site-footer__admin">Admin</Link></li>
              </ul>
            </div>

            <div className="site-footer__col">
              <h2 className="site-footer__heading">Operators</h2>
              <ul role="list">
                {SITE.operators.map((name) => (
                  <li key={name}>
                    {SITE.operatorLinks?.[name] ? (
                      <a href={SITE.operatorLinks[name]} target="_blank" rel="noopener noreferrer" aria-label={`${name} on LinkedIn`}>
                        {name}
                      </a>
                    ) : (
                      name
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="site-footer__col">
              <h2 className="site-footer__heading">Contact</h2>
              <ul role="list">
                <li>
                  <a href={`mailto:${SITE.contactEmail}`} className="site-footer__mail">
                    {SITE.contactEmail}
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="site-footer__bottom">
          <p>© 2026 PAWNI · {SITE.domain}</p>
          <p className="site-footer__made">Built in India</p>
        </div>
      </div>
    </footer>
  );
}
